import React from 'react';
import { Typography, Space, theme } from 'antd';
import IconBadge from './IconBadge';

const { Title, Text } = Typography;
const { useToken } = theme;

// Header estándar de una página.
// - title: string | ReactNode (requerido)
// - subtitle: string | ReactNode
// - icon: componente de @ant-design/icons (opcional; si no hay, no se dibuja badge)
// - tint: color del icono (default: colorPrimary)
// - actions: ReactNode a la derecha (Select, Button, filtros, etc.)
// - level: 1-5 para Typography.Title (default 3)
// - bordered: línea divisoria inferior (default true)
function PageHeader({
  title,
  subtitle,
  icon,
  tint,
  actions,
  level = 3,
  bordered = true,
}) {
  const { token } = useToken();
  const resolvedTint = tint ?? token.colorPrimary;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: token.marginMD,
        marginBottom: token.marginXL,
        paddingBottom: bordered ? token.paddingMD : 0,
        borderBottom: bordered ? `1px solid ${token.colorBorder}` : 'none',
      }}
    >
      <Space align="start" size={14} style={{ minWidth: 0 }}>
        {icon && <IconBadge icon={icon} tint={resolvedTint} size="lg" />}
        <div style={{ minWidth: 0 }}>
          <Title level={level} style={{ margin: 0 }}>
            {title}
          </Title>
          {subtitle && <Text type="secondary">{subtitle}</Text>}
        </div>
      </Space>
      {actions && <div style={{ flexShrink: 0 }}>{actions}</div>}
    </div>
  );
}

export default PageHeader;
